import { useEffect } from "react";
import withShow from "@common/withShow";
import { Flex } from "@components/index";
import Loading from "@fragments/Loading.fragment";
import {
  useFilterContext,
  ViewsEnum,
} from "@pages/Dashboard/contexts/Filter.context";
import { useGanttDataContext } from "@pages/Dashboard/contexts/GanttData.context";
import Empty from "@fragments/Empty.fragment";
import { useGetTimeline } from "@services/timeline/hooks";
import FooterTimelineFragment from "../../FooterTimeline/FooterTimeline.fragment";
import GanttGerencial from "./componentes/GanttGerencial.component";
import GanttDetalhada from "./componentes/GanttDetalhada.component";
import styles from "./Gantt.module.scss";

const GanttView: React.FC = () => {
  const { date, view } = useFilterContext();
  const isDetalhada = view === ViewsEnum.detalhada;

  const { data, isLoading, isFetching, isFetched } = useGetTimeline(date, view);
  const { mapGroupD1 = [], mapGroupD2 = [], updateData } = useGanttDataContext();

  useEffect(() => {
    if (data && updateData) {
      updateData(data);
    }
  }, [data, updateData]);

  const day = [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");

  const isLoadingState = isLoading || (isFetching && !isFetched) || (!data && !isFetched);

  const hasData = Boolean(data && isFetched && (mapGroupD1?.length > 0 || mapGroupD2?.length > 0));

  if (isLoadingState) {
    return (
      <Flex.Row className={styles["h-100"]}>
        <Loading show />
      </Flex.Row>
    );
  }

  if (isFetched && hasData) {
    return (
      <Flex.Col className={styles.wrapper}>
        {isDetalhada ? (
          <GanttDetalhada day={day} isFetched={isFetched} isFetching={isFetching} />
        ) : (
          <GanttGerencial day={day} />
        )}
        <FooterTimelineFragment />
      </Flex.Col>
    );
  }

  return (
    <Flex.Row className={styles["h-100"]}>
      <Empty show>Sem eventos</Empty>
    </Flex.Row>
  );
};

export default withShow(GanttView);